export const ACCEPT_IMAGE_MIME_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/tiff'] as const;
export const ACCEPT_MIME_TYPES = ['application/pdf', ...ACCEPT_IMAGE_MIME_TYPES] as const;
